import React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import {
  settingsAccordionDetails,
  settingsInInteractiveCalculator,
} from "../components/constants";

export default function SimplePaper({ title, body }) {
  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "95%", md: "90%" },
        margin: "0 auto",
        padding: "0 0 1rem 0",
        backgroundColor: "inherit",
      }}
    >
      <Paper
        elevation={5}
        sx={{
          padding: {
            xs: "0.7rem 1rem 0.7rem 1rem",
            sm: "0.9rem 1.5rem 0.9rem 1.5rem",
            md: "1.2rem 2rem 1.2rem 2rem",
          },
          marginTop: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          backgroundColor: settingsInInteractiveCalculator,
          borderRadius: "16px 16px 0 0",
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
        </Container>
      </Paper>
      <Paper
        elevation={5}
        sx={{
          padding: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          marginTop: "0rem",
          backgroundColor: settingsAccordionDetails,
          borderRadius: "0 0 16px 16px",
        }}
      >
        <Container maxWidth="lg"> {body} </Container>
      </Paper>
    </Box>
  );
}
